const COMMENTS = [
  {
    name: '追漫小王子',
    text: '用了爱漫画网的下拉式阅读模式之后真的回不去了！刷漫画就像刷短视频一样流畅，无弹窗体验太舒服了，再也不用担心看到关键时刻突然弹广告。全屏观看战斗场面简直炸裂，强烈推荐给所有漫画党！',
    tag: '下拉式漫画阅读爱好者',
    time: '3天前',
  },
  {
    name: '深夜追更人',
    text: '作为一个每天通勤两小时的上班族，移动端的翻页漫画模式是我的最爱。界面简洁不花哨，翻页动画自然流畅，而且完全免费！最近在追咒术回战，每次最新话更新都能第一时间看到，真的太良心了。',
    tag: '翻页漫画忠实用户',
    time: '5天前',
  },
  {
    name: '漫画老司机',
    text: '从纸质漫画时代一路看到现在，爱漫画网的无弹窗漫画体验让我找回了最初看漫画的那种纯粹快乐。没有花花绿绿的广告，没有莫名其妙的跳转，就是干干净净的漫画页面。收藏夹已经塞满了，希望平台越做越好！',
    tag: '十年漫画读者',
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
            <i className="ri-chat-quote-line text-accent-600 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者心声</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-2xl p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">{c.name[0]}</span>
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-800">{c.name}</div>
                  <div className="text-[11px] text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">{c.text}</p>
              <span className="text-[11px] font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md w-fit whitespace-nowrap">
                {c.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}